<template>
<div>

  <el-row>
    <el-col :span="24">
      <div class="grid-content bg-purple-light">

        <div class="searchTitle">
          <b> GPS 배치 실행 결과 화면   </b>
        </div>

        <!-- 조회 조건 영역 -->
        <div class="searchBody">


<!--          <div style="margin-left: 20px">-->
<!--            GPS :-->
<!--          </div>-->
<!--          <div class="searchBody">-->

<!--            <el-input-->
<!--                    class="wide-input"-->
<!--                    style="margin-left: 10px;"-->
<!--                placeholder=""-->
<!--                v-model="gps"-->

<!--            >-->
<!--            </el-input>-->

<!--            <div style="margin-left: 20px">-->
<!--              <el-button-->
<!--                  :loading="loading"-->
<!--                  type="primary"-->
<!--                  @click="gpsSave"-->
<!--              >저장</el-button>-->
<!--            </div>-->
<!--          </div>-->

        </div>
      </div> <!-- div class="grid-content bg-purple-light"> -->
    </el-col>

  </el-row>

  <el-row v-if="false">
    <el-col :span="24">
      <div class="grid-content bg-purple-light">

        <!-- 조회 조건 영역 -->
        <div class="searchBody">
          <div class="searchBody">

          </div>

        </div>
      </div> <!-- div class="grid-content bg-purple-light"> -->
    </el-col>

  </el-row>

  <el-row>
    <el-col :span="24">
      <div class="grid-content bg-purple-light">
        <div class="searchTitle">
          <b> GPS Batch Log </b>
        </div>

        <el-table
            v-loading="loading"
            ref="multipleTable"
            :data="tableData"
            style="width: 100%; height:100%"
            border
            size="small"
            :row-class-name="tableRowClassName"
            :row-style="{ height: 0 + 'px' }"
            :cell-style="{ padding: 0 + 'px' }"
            :header-cell-style="{
              background: '#2F384E',
              color: '#fff',
              height: '10px',
              padding: '0px',
            }"
        >
          <el-table-column property="batch_job_log_seq" label="seq" width="80"></el-table-column>
          <el-table-column property="start_date" label="start_date" width="190"></el-table-column>
          <el-table-column property="end_date" label="end_date" width="190"></el-table-column>
          <el-table-column property="status" label="status" width="130"></el-table-column>
          <el-table-column property="updated_rows" label="updated_rows" width="110"></el-table-column>
          <el-table-column property="failed_count" label="failed_count" width="110"></el-table-column>
          <el-table-column property="cache_updated_rows" label="Cache update" width="120"></el-table-column>
          <el-table-column property="tomtom_calls" label="TomTom calls" width="115"></el-table-column>
          <el-table-column property="tomtom_updated_rows" label="TomTom update" width="125"></el-table-column>
          <el-table-column property="naver_calls" label="Naver calls" width="110"></el-table-column>
          <el-table-column property="message" label="message" min-width="450" show-overflow-tooltip></el-table-column>
        </el-table>

        <div style="text-align:center; margin-top: 10px;">
          <el-pagination
              :current-page.sync="currentPage"
              :page-size="pageSize"
              :total="totalSize"
              layout="prev, pager, next"
              @current-change="handleCurrentChange">
          </el-pagination>
        </div>

        <div style="display: flex; justify-content: flex-end; margin-top: 12px;">
          <el-button
              :loading="loading"
              type="primary"
              @click="search"
          >재조회</el-button>
          <el-button
              :loading="loading"
              type="primary"
              @click="allCountryUpdate"
          >BATCH START</el-button>
        </div>
      </div>
    </el-col>
  </el-row>
</div>
</template>

<script>
import Axios from 'axios';

  export default {
    created() {

      document.onkeydown = this.NotReload;


      this.$store.commit("dayBefore",0);
      this.requestEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜
      this.$store.commit("dayBefore",7);
      this.requestStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일

      // this.$store.state.accessToken

      if (this.$store.state.userId != 'admin') {
        this.deptSeqOption = this.$store.state.deptSeq;
        this.deptNameOption = this.$store.state.deptName;
      }


      // 페이지로딩시 조회
      this.search();


      // 주소 업데이트는 서버 gps-2 batch 로직을 직접 실행한다.

    },//created
    data() {
      return {
        // table 관련 data
        tableData: [],
        totalData: [],
        multipleSelection: [],
        currentPage: 1,
        pageSize:10,
        totalSize:0,
        // loading 변수 true 이면 loging 화면 보여줌
        loading:false,
        // 조회조건 관련 변수
        brandOptions: [{
          value: 'CW',
          label: 'CW'
        }, {
          value: 'KO',
          label: 'KO'
        }, {
          value: 'CM',
          label: 'CM'
        }, {
          value: 'KS',
          label: 'KS'
        },],
        brandOption: '',
        styleOption :'',
        deptNameOption:'',
        deptSeqOption:0,
        requestStartDateOption:'',
        requestEndDateOption:'',
        statusOption:'',
        loss:'3',
        deptNameDisabled:'false',
        dialogVisible: false,
        gps : '',
        latitude : '',
        longitude : '',
        formatted_address : '',
        country : '',
        administrative_area_level_1 : '',


      }
    },//data//

    methods: {


      async  allCountryUpdate(){




        console.log("==============allCountryUpdate================");
        this.loading = true;

        let url = this.$url + '/authInfo/runGpsBatchOnce';

        await Axios.post(url, {}, this.$store.state.config).then(res => {
          let result = res.data || {};
          this.$message.success(
              'GPS batch ' + result.status
              + ' / 대상 ' + result.targetCount
              + ' / 수정 ' + result.updatedRows
              + ' / 실패 ' + result.failedCount
              + ' / 잔여 ' + result.remainingCount
          );
          this.$message.info(
              'Cache update ' + result.cacheUpdatedRows
              + ' / TomTom calls ' + result.tomTomCallCount
              + ' / TomTom update ' + result.tomTomUpdatedRows
              + ' / Naver calls ' + result.naverCallCount
          );
          this.loading = false;
          this.search();
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.loading = false;
        });
      }, //allCountryUpdate

      gpsSave(){


        const tmpGps = this.gps.split(',');

        this.latitude = tmpGps[0].trim();
        this.longitude = tmpGps[1].trim();

        this.formatted_address = '';
        this.country = '';
        this.administrative_area_level_1 = '';
        this.chkQrCode();

      },


      async chkQrCode(){
        this.loading = true;
        // default data
        let url = this.$url + '/rfidInfo/chkQrCode';
        var reqJson = new Object();
        reqJson.auth_code = '78274173'
        reqJson.latitude = this.latitude
        reqJson.longitude = this.longitude
        reqJson.formatted_address = this.formatted_address;
        reqJson.country = this.country;
        reqJson.administrative_area_level_1 = this.administrative_area_level_1;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.rfidInfoDTO;


          console.log(resDataJson);

          // for(var resData in resDataJson){
          //   this.authKey =  resDataJson[resData]['auth_key'];
          //   this.chkFlag =  resDataJson[resData]['chk_flag'];
          //   this.checkCount =  resDataJson[resData]['check_count'];
          //   this.mainDiv = "mainBody" + resDataJson[resData]['rfid_get_order_seq'];
          // }
          //
          // if (this.chkFlag =="false")
          // {
          //   this.$message.success("가품으로 의심됩니다.");
          //   this.successFlag = false;
          //   this.failFlag = true;
          // }else {
          //   this.$message.success("정품 입니다.");
          //   this.successFlag = true;
          //   this.failFlag = false;
          // }

          this.$message.success("저장 완료.");
          this.loading = false;
        }) // await Axios.post
            .catch(error => {

              this.successFlag = false;
              this.failFlag = true;

              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.currentPage = 1;
              this.loading = false;
            }); // await Axios.post
      },//chkQrCode

      NotReload() {
        if ((event.ctrlKey == true && (event.keyCode == 78 || event.keyCode == 82)) || (event.keyCode == 116)) {
          event.keyCode = 0;
          event.cancelBubble = true;
          event.returnValue = false;
        }
      },

      handleClose() {
        this.dialogVisible = false;
      },

      async search(){
        this.loading = true;

        let url = this.$url + '/authInfo/getBatchJobLogList';

        await Axios.post(url, {}, this.$store.state.config ).then(res => {
          var resDataJson = res.data.batchJobLogDTO
          this.totalData=[];
          if (res.data.resultCode){
            for(var resData in resDataJson){
              this.totalData.push({
                  seq : resData
                , batch_job_log_seq: resDataJson[resData]['batch_job_log_seq']
                , start_date: resDataJson[resData]['start_date']
                , end_date: resDataJson[resData]['end_date']
                , status: resDataJson[resData]['status']
                , target_count: resDataJson[resData]['target_count']
                , updated_rows: resDataJson[resData]['updated_rows']
                , failed_count: resDataJson[resData]['failed_count']
                , cache_updated_rows: this.extractBatchMetric(resDataJson[resData]['message'], 'cache_updated_rows')
                , tomtom_calls: this.extractBatchMetric(resDataJson[resData]['message'], 'tomtom_calls')
                , tomtom_updated_rows: this.extractBatchMetric(resDataJson[resData]['message'], 'tomtom_updated_rows')
                , naver_calls: this.extractBatchMetric(resDataJson[resData]['message'], 'naver_calls')
                , message: resDataJson[resData]['message']
              });
            }
            // 전체 데이터 사이즈
            this.totalSize = this.totalData.length;
            // 보여주는 부분만 slice
            this.tableData = this.totalData.slice(0, this.pageSize);
            this.currentPage = 1;
            this.loading = false;
            this.$message.success(this.$store.state.searchSuccess);
          }else {
            this.$message.error(this.$store.state.dataNotFound);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
        .catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      },//search

      extractBatchMetric(message, key) {
        if (!message) {
          return '-';
        }
        const match = message.match(new RegExp('(?:^|\\|)\\s*' + key + '=(\\d+)'));
        return match ? Number(match[1]) : '-';
      },

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      }, //toggleSelection

      // check box click event
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      tableRowClassName({row}) {
        const targetCount = Number(row.target_count) || 0;
        const updatedRows = Number(row.updated_rows) || 0;
        const failedCount = Number(row.failed_count) || 0;
        const hasProblem = failedCount > 0 || (targetCount > 0 && updatedRows === 0);
        return hasProblem ? 'gps-zero-updated-row' : '';
      },
      handleSizeChange(val) {
        console.log(`${val} items per page`);
      },

      // pagging event
      handleCurrentChange(val) {
        this.tableData = this.totalData.slice( (this.pageSize * val - this.pageSize )   , this.pageSize * val);
      },


      save(){

        if (this.multipleSelection.length <= 0)
        {
          this.$message.error(this.$store.state.noDataSelect);
          return ;
        }
        this.dialogVisible = false;
        this.loading = true;
        let url = "";
        url = this.$url + '/rfidGetOrder/update';
        // const json = { 'user_id': this.$store.state.userId };

        // for(var resData in this.multipleSelection){
        //   this.multipleSelection[resData]['address1'] = this.$store.state.address1
        //   this.multipleSelection[resData]['address2'] = this.$store.state.address2
        //   this.multipleSelection[resData]['reg_user_id'] = this.$store.state.userId
        //   this.multipleSelection[resData]['upd_user_id'] = this.$store.state.userId
        //   this.multipleSelection[resData]['rfid_order_confirm_amount'] =  this.multipleSelection[resData]['rfid_order_confirm_amount'] *=1;
        // }

        Axios.post(url,
                      this.multipleSelection
                    , this.$store.state.config ).then(res => {

          // console.log("=========================Axios.pos.SAVE================================" );
          // console.log(res.data);

          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.search(false);

        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      }, // save

      percent(){

        for(var resData in this.tableData) {
          this.tableData[resData]['rfid_order_amount'] =  Math.ceil(this.tableData[resData]['rfid_order_amount'] * 1.03 );
        }

      },
    }, //methods
  } // export default
</script>


<style>

#lossInput {
  height: 20px !important;
  width : 70px  !important;
  border: 1px solid #2C5AA0 !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  /* // font-family: Segoe UI,Malgun Gothic !important;
  // font-weight: 400 !important; */
  font-size: 9px !important;
  cursor: pointer !important;
  padding: 0 6px !important;
  margin-left: 100px !important;
}

#percent{
  height: 20px !important;
  align-items: center !important;
  display: flex !important;
}

.el-dialog__header {
   padding: 0px !important;
}

el-dialog__footer {
  padding: 0px !important;
}


#gpsInput {
  height: 20px !important;
  width: 250px !important;
  border: 1px solid #2C5AA0 !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  font-size: 9px !important;
  /*cursor: pointer !important;*/
  padding: 0 6px !important;
}

.el-table .gps-zero-updated-row {
  color: #d60000 !important;
}

.el-table .gps-zero-updated-row td,
.el-table .gps-zero-updated-row td .cell {
  color: #d60000 !important;
}

</style>
